var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticStyle:{"width":"50%","margin":"auto"},attrs:{"column":"","align-center":""}},[_c('intro'),_c('icon-bar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }